export default __webpack_public_path__ + "static/media/master-class-0.5f7a8ba1.jpeg";